import React from 'react';
import Table from 'react-bootstrap/Table';
import Scroll from 'react-scroll';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Select from 'react-select';
import DateTimePicker from 'react-datetime-picker';
import Moment from 'moment';
import { FaList, FaPencilAlt } from 'react-icons/fa';
import Modal from 'react-bootstrap/Modal';

import CompanyAPI from '../api/CompanyAPI';
import ApiUiController from '../controller/ApiUiController';

class CompanyList extends React.Component {

  constructor(props) {
    super(props);
    this.Types = [ {label: 'All', value: 0}, {label: 'Sales', value: 1}, {label: 'Service', value: 2}, {label: 'Realestate', value: 3} ];
    this.state = { inApiCall: false, show: false, type: this.Types[0], name: '', from: null, to: null, company: {} };
    this.companies = [];
  }

  componentDidMount() {
    this.loadCompanies();
  }

  clearCompanies = () => {
    const body = { filter: { type: 0, name: '', valid: '' }, limit: 500, page: 1 };
    this.setState({ ...this.state, type: this.Types[0], name: '', from: null, to: null, inApiCall: true });
    CompanyAPI.list(body, this.onResponse, this.onFail);
  }

  loadCompanies = () => {
    let valid = '';
    const from = this.state.from;
    const to = this.state.to;
    if(from && to) {
      from.setHours(0); 
      from.setMinutes(0);
      from.setSeconds(0);

      to.setHours(23); 
      to.setMinutes(59);
      to.setSeconds(59);
      valid = this.DateToServerDateTime(from) + '~' + this.DateToServerDateTime(to);
    }
    const body = {
      filter: {
        type: this.state.type ? this.state.type.value : 0,
        name: this.state.name,
        valid: valid
      },
      limit: 500,
      page: 1
    }
    this.setState({ ...this.state, inApiCall: true });
    CompanyAPI.list(body, this.onResponse, this.onFail);
  }

  onResponse = res => {
    this.companies = res.data;
    this.setState({ ...this.state, inApiCall: false });
  }

  onFail = () => {
    this.setState({ ...this.state, inApiCall: false });
  }

  DisplayDate = from => Moment(Moment.utc(from, 'YYYY-MM-DD HH:mm:ss').toDate()).format('DD-MM-YYYY');
  DateToServerDateTime = from => Moment(from).utc().format('YYYY-MM-DD HH:mm:ss');
  serverStringToDate = from => Moment.utc(from, 'YYYY-MM-DD HH:mm:ss').toDate();
  
  onHide = () => this.setState({ ...this.state, show: false });
  onPreview = index => window.location.href = window.location.href + '/user/' + this.companies[index].id;
  onEdit = index => this.setState({ ...this.state, show: true, company: { ...this.companies[index] } });

  onSave = () => {
    const body = { ...this.state.company };
    this.setState({ ...this.state, show: false, inApiCall: true });
    CompanyAPI.update(body, this.loadCompanies, this.onFail);
  }

  render() {
    let rows = <tr><td colSpan="10">No records Found</td></tr>;
    if(this.companies.length > 0) {
      rows = this.companies.map((company, i) =>
        <tr key={`company_${i}`}>
          <td>{company.id}</td>
          <td>{this.Types.find(type => type.value === company.crm_type) ? this.Types.find(type => type.value === company.crm_type).label : i}</td>
          <td>{company.name}</td>
          <td>{company.admin_name}</td>
          <td>{company.admin_no}</td>
          <td>{company.admin_email}</td>
          <td>{this.DisplayDate(company.valid_till)}</td>
          <td>{company.allocated_users}</td>
          <td>{company.active_users}</td>
          <td>{company.total_users}</td>
          <td>
            <FaList className="actionbtnp" onClick={() => this.onPreview(i)} />
            <FaPencilAlt className="actionbtne" onClick={() => this.onEdit(i)} />
          </td>
        </tr>
      );
    }
    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        <Modal aria-labelledby="contained-modal-title-vcenter" size="lg" className="w-660" centered
          show={this.state.show} onHide={this.onHide} onExit={() => this.onHide}>

          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">Edit Company Info</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form key="form">
              <div className="row">
                <Form.Group as={Col}>
                  <label>Name</label>
                  <FormControl className="name" type="text" value={this.state.company.name}
                    onChange={event => this.setState({ ...this.state, 
                      company: { ...this.state.company, name: event.target.value } })} />
                </Form.Group>
              </div>

              <div className="row">
                <Form.Group as={Col}>
                  <label>Admin Name</label>
                  <FormControl className="name" type="text" value={this.state.company.admin_name}
                    onChange={event => this.setState({ ...this.state, 
                      company: { ...this.state.company, admin_name: event.target.value } })} />
                </Form.Group>
                <Form.Group as={Col}>
                  <label>Admin No</label>
                  <FormControl className="name" type="text" value={this.state.company.admin_no}
                    onChange={event => this.setState({ ...this.state, 
                      company: { ...this.state.company, admin_no: event.target.value } })} />
                </Form.Group>
                <Form.Group as={Col}>
                  <Scroll.Element name="name" />
                  <label>Admin Email</label>
                  <FormControl className="name" type="text" value={this.state.company.admin_email}
                    onChange={event => this.setState({ ...this.state, 
                      company: { ...this.state.company, admin_email: event.target.value } })} />
                </Form.Group>
              </div>

              <div className="row">
                <Form.Group as={Col}>
                  <label>Valid Till</label>
                  <DateTimePicker className="col-md-6" format="dd-MM-y" 
                    value={this.serverStringToDate(this.state.company.valid_till)}
                    onChange={ date => {
                        date.setHours(23); 
                        date.setMinutes(59);
                        date.setSeconds(59);
                        this.setState({ ...this.state, company: { ...this.state.company, 
                          valid_till: this.DateToServerDateTime(date) } })
                      }
                    }
                  />
                </Form.Group>
                <Form.Group as={Col}>
                  <label>Allocated Users</label>
                  <FormControl className="name" type="number" value={this.state.company.allocated_users}
                    onChange={event => this.setState({ ...this.state, 
                      company: { ...this.state.company, allocated_users: event.target.value } })} />
                </Form.Group>
              </div>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={this.onSave}>Submit</Button>
          </Modal.Footer>
        </Modal>

        <div><h1>Company List</h1></div>
        <div>
          <h3>Search</h3>
        </div>
        <Form className="row row-cols-3 lead-form">
          <Form.Group as={Col}>
            <Scroll.Element name="name" />
            <label>Text</label>
            <FormControl className="name" type="text" value={this.state.name}
              onChange={event => this.setState({ ...this.state, name: event.target.value })} />
          </Form.Group>

          <Form.Group as={Col}>
            <Scroll.Element name="type" />
            <label>CRM Type</label>
            <Select value={this.state.type} options={this.Types}
              onChange={seletced => this.setState({ ...this.state, type: seletced })} />
          </Form.Group>

          <Form.Group as={Col}>
            <Scroll.Element name="type" />
            <label>Valid Date</label>
            <DateTimePicker className="col-md-6" format="dd-MM-y" value={this.state.from}
              onChange={date => this.setState({ ...this.state, from: date })} />
            <DateTimePicker className="col-md-6" format="dd-MM-y" value={this.state.to}
              onChange={date => this.setState({ ...this.state, to: date })} />
          </Form.Group>

          <Form.Group as={Col}>
            <Button onClick={this.clearCompanies} className="btnsub btn btn-primary btn-lg btn-block"> Clear </Button>
            <Button onClick={this.loadCompanies} className="btnsub btn btn-primary btn-lg btn-block"> Search </Button>
        </Form.Group>   
        </Form>

        
        <Table striped bordered hover className="table-cursor">
        <thead>
          <tr>
            <th rowSpan="2">Id</th>
            <th rowSpan="2">Type</th>
            <th rowSpan="2">Name</th>
            <th rowSpan="2">Admin Name</th>
            <th rowSpan="2">Admin No</th>
            <th rowSpan="2">Admin Email</th>
            <th rowSpan="2">Valid Till</th>
            <th>Allocated</th>
            <th>Active</th>
            <th>Total</th>
            <th>Action</th>
          </tr>
          <tr>
            <th colSpan="3">Users</th>
          </tr>
        </thead>

        <tbody>{rows}</tbody>
        </Table>
      </ApiUiController>
    );
  }
}
export default CompanyList;
